// Formatação pt-BR num lugar só — cópia enxuta do app/src/lib/formato.ts
// (regra 9 do CLAUDE.md: dinheiro em pt-BR é traiçoeiro; o formato é um só).

const moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const dataHora = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

export const brl = (v: number | null | undefined): string =>
  v === null || v === undefined ? '—' : moeda.format(v);

export const dataHoraBR = (iso: string | null | undefined): string =>
  iso ? dataHora.format(new Date(iso)) : '—';

/** Quantidade sem zeros mortos ("2", "1,5"). */
export const qtd = (v: number): string =>
  String(v).replace('.', ',');
